import { render, staticRenderFns } from "./data-config.vue?vue&type=template&id=5e29e9a5"
import script from "./data-config.vue?vue&type=script&lang=ts"
export * from "./data-config.vue?vue&type=script&lang=ts"
import style0 from "./data-config.vue?vue&type=style&index=0&id=5e29e9a5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports